import { put, takeEvery, call } from "redux-saga/effects";
import updateShiftDefinition from "sc/backend/oncall/partners/shifts-definitions/update";
import {
  shiftDefinitionUpdated,
  REQUEST_UPDATE_SHIFT_DEFINITION,
  shiftDefinitionError,
} from "../../actions/shifts-definitions";

const requestUpdate = function*(action) {
  try {
    const result = yield call(
      updateShiftDefinition,
      action.payload.id,
      action.payload.startDate,
      action.payload.startTime,
      action.payload.days,
      action.payload.endTime,
      parseInt(action.payload.priority, 10),
    );
    yield put(
      shiftDefinitionUpdated(
        action.payload.id,
        result.id,
        action.payload.startDate,
        action.payload.startTime,
        action.payload.days,
        action.payload.endTime,
        action.payload.priority,
      ),
    );
  } catch (error) {
    yield put(shiftDefinitionError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeEvery(REQUEST_UPDATE_SHIFT_DEFINITION, requestUpdate);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/shifts-definitions/request-update.js